import api from './axios';

export const adminPlanTierApi = {
  list: (params = {}) => api.get('/admin/plan-tiers', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/plan-tiers/${id}`).then((r) => r.data),
  create: (data) => api.post('/admin/plan-tiers', data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/plan-tiers/${id}`, data).then((r) => r.data),
  deactivate: (id) => api.delete(`/admin/plan-tiers/${id}`).then((r) => r.data),
};

export const adminPlanPriceApi = {
  list: (params = {}) => api.get('/admin/subscription-plans', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/subscription-plans/${id}`).then((r) => r.data),
  create: (data) => api.post('/admin/subscription-plans', data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/subscription-plans/${id}`, data).then((r) => r.data),
  deactivate: (id) => api.delete(`/admin/subscription-plans/${id}`).then((r) => r.data),
};

export const adminPlanAddonApi = {
  list: (params = {}) => api.get('/admin/plan-addons', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/plan-addons/${id}`).then((r) => r.data),
  create: (data) => api.post('/admin/plan-addons', data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/plan-addons/${id}`, data).then((r) => r.data),
  deactivate: (id) => api.delete(`/admin/plan-addons/${id}`).then((r) => r.data),
};
